import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { cn } from '@talentmesh/ui/lib/utils';
import { useFormContext } from 'react-hook-form';
import { JobAdFieldTypes } from '../JobAdStepUtils';
import WingsIcon from './WingsIcon';
import UIStrings from '@/Utils/UIStrings';

interface JobAdTitleProps {
    loading?: boolean;
}

function JobAdTitle({ loading = false }: JobAdTitleProps) {
    const { formState } = useFormContext();

    return (
        <RHFInput
            name={JobAdFieldTypes.Title}
            label={UIStrings.JobAdTitle}
            fieldDataCy={JobAdFieldTypes.Title}
            placeholder={loading ? '' : UIStrings.CustomizeTheJobPostTitle}
            disabled={formState.isSubmitting || loading}
            className={cn(loading && 'pl-11 disabled:opacity-100')}
            inputOverlay={loading && <WingsIcon />}
        />
    );
}

export default JobAdTitle;
